import { Action, Dispatch } from "redux";
import { AsyncActionCreators } from "typescript-fsa";
import { ApiClient } from "../state/ducks/api-clients";
import { ApiException } from "../api/api";
import { localizedDynamic, localized } from "../state/i18n/i18n";
import { showError } from "../state/snackbar/operations";
import { logOutAuth } from "../state/ducks/auth/operations";

type ErrorResponse = {
  message: string;
};

export const AsyncOperationBuilder = <TApiInput, TApiReturn>(
  action: AsyncActionCreators<TApiInput, TApiReturn, any>,
  apiCall: (cl: ApiClient) => Promise<TApiReturn>,
  apiInput: TApiInput,
  client: ApiClient
) => async (dispatch: Dispatch<Action<any>>) => {
  dispatch(action.started(apiInput));
  try {
    let apiReturnValue: TApiReturn = await apiCall(client);
    dispatch(action.done({ params: apiInput!, result: apiReturnValue } as any));
  } catch (error) {
    if (error.status) {
      let apiException = error as ApiException;
      const responseFromJson = JSON.parse(
        apiException.response
      ) as ErrorResponse;
      let message: string = "";
      if (responseFromJson) {
        const localizedResponseIfAny = localizedDynamic(
          responseFromJson.message
        );
        message = localizedResponseIfAny || apiException.message;
      }
      showError(message)(dispatch);
      dispatch(
        action.failed({
          params: apiInput!,
          error: { code: apiException.status, message: apiException.message },
        } as any)
      );
      if (apiException.status === 401) {
        showError(localized("Unauthorized"))(dispatch);
        logOutAuth()(dispatch);
      }
    } else {
      showError(localized("Error"))(dispatch);

      dispatch(
        action.failed({
          params: apiInput!,
          error: { code: 0, message: error.toString() },
        } as any)
      );
    }
  }
};
